import React from 'react';
import { Sprite } from '@agissc/ktag-map';
import classNames from 'classnames';

interface IdentifyMessageBoxProps {
  message: string | React.ReactNode;
  type: 'information' | 'negative';
}

const IdentifyMessageBox = ({ message, type }: IdentifyMessageBoxProps) => {
  return (
    <div className="identifyError">
      <p>
        <Sprite
          id={type === 'negative' ? 'exclamation-circle' : 'i-circle'}
          additionalClassNames={classNames('identify_message_icon', {
            identify_error_icon: type === 'negative',
          })}
        />
        {message}
      </p>
    </div>
  );
};

export default IdentifyMessageBox;
